{
  "title": "Divination",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level divination (ritual)",
  "level": 4,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (incense and a sacrificial offering appropriate to your religion, together worth at least 25 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "Your magic and an offering put you in contact with a god or a god’s servants. You ask a single question concerning a specific goal, event, or activity to occur within 7 days. The DM offers a truthful reply. The reply might be a short phrase, a cryptic rhyme, or an omen.",
    "The spell doesn’t take into account any possible circumstances that might change the outcome, such as the casting of additional spells or the loss or gain of a companion.",
    "If you cast this spell two or more times before finishing your next long rest, there is a cumulative 25 percent chance for each casting after the first that you get a random reading. The DM makes this roll in secret."
  ],
  "spellLists": ["cleric", "druid", "wizard"]
}
